// extracted by mini-css-extract-plugin
module.exports = {"container":"ServiceHistoryError_container__8saa9","spin":"ServiceHistoryError_spin__nhrlq","pulse":"ServiceHistoryError_pulse__3B3Oe"};